import { HttpBadStatusCodeError, HttpBodyParseError, HttpTimeoutError } from '@cian/core/errors';
import { ResponseError } from 'shared/map-search/utils/errors/ResponseError';

import { EClustersFailReason } from '../constants';

const SERVER_ERROR_STATUS_CODE = 500;

/**
 * Классифицирует ошибку загрузки кластеров для сегментации метрики fail.
 *
 * Классифицируем только то, что опознаём уверенно. Всё остальное уходит в Unknown —
 * когда метрики поедут, по доле Unknown будет видно, что стоит доклассифицировать.
 */
export function resolveFailReason(error: unknown): EClustersFailReason {
  if (HttpTimeoutError.isLike(error)) {
    return EClustersFailReason.Timeout;
  }

  if (HttpBodyParseError.isLike(error)) {
    return EClustersFailReason.BadPayload;
  }

  /**
   * Ответ 400 приходит от ручки кластеров как валидный типизированный ответ
   * и превращается в ResponseError в assertUnknownError, поэтому до HttpBadStatusCodeError не доходит.
   */
  if (error instanceof ResponseError) {
    return EClustersFailReason.BadRequest;
  }

  if (HttpBadStatusCodeError.isLike(error)) {
    return error.statusCode >= SERVER_ERROR_STATUS_CODE ? EClustersFailReason.Http5xx : EClustersFailReason.Http4xx;
  }

  return EClustersFailReason.Unknown;
}
